import 'react-datepicker/dist/react-datepicker.css';

import axios from 'axios';
import { WorkflowAdminReqeust } from 'data/MasterEmployee/schemas/MasterEmployee.shema';
import {
    MasterCompanyList,
    MasterCompanyResponse
} from 'models/company/MasterCompany';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { BsCalendar2Date } from 'react-icons/bs';
import { FaSearch } from 'react-icons/fa';
import { Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import {
    getWorkflowCallbackLog,
    updateWorkflowCallbackLog
} from 'data/CallbackLog/repositories/CallbackLog.repository';
import {
    LogCallBackInfo,
    WorkflowCallBackLogParams
} from 'data/CallbackLog/schemas/CallbackLog.schema';
import { ResponseList } from 'models/Response';
import CallbackLogTable from './components/CallbackLogTable';
import CallbackLogDetail from './components/CallbackLogDetail';
import Swal from 'sweetalert2';
import useLoader from 'hooks/useLoader';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useAdminCompanies } from '../../../hooks';
import dayjs from 'dayjs';

function CallbackLog() {
    const loading = useLoader();
    const location = useLocation();

    const { adminCompanies } = useAdminCompanies();

    const [companyMaster, setCompanyMater] = useState<MasterCompanyList[]>();
    const [selectdAllCompany, setSelectdAllCompany] = useState<boolean>(true);
    const [explorerDetail, setExplorerDetail] = useState<boolean>(false);
    const [callbackLogDetail, setCallbackLogDetail] =
        useState<LogCallBackInfo>();
    const [searchHelp, setSearchHelp] = useState<WorkflowCallBackLogParams>({
        doc_no: '',
        sid: '*',
        instance_no: '',
        from: '',
        to: '',
        status: ''
    });
    const [workflowLogResponse, setWorkflowLogResponse] =
        useState<ResponseList<LogCallBackInfo>>();

    useEffect(() => {
        const { instance_no, status, backdate } = queryString.parse(
            location.search
        );
        if (!instance_no && !status && !backdate) {
            return;
        }

        const queryInstanceNo =
            instance_no && typeof instance_no === 'string' ? instance_no : '';
        const queryStatus = !status ? 'W,E' : status === 'error' ? 'E' : 'W';
        const queryFrom =
            typeof backdate === 'string' && !Number.isNaN(parseInt(backdate))
                ? dayjs()
                      .subtract(parseInt(backdate), 'day')
                      .format('YYYYMMDDHHmmss')
                : '';

        if (queryFrom) {
            setSearchHelp(prev => ({ ...prev, from: queryFrom }));
        }

        void (async function () {
            const response = await fetchCallbackLog({
                doc_no: '',
                sid: '*',
                instance_no: queryInstanceNo,
                from: queryFrom,
                to: '',
                status: queryStatus
            });

            if (response?.result_list?.length === 1) {
                const log = response.result_list[0];
                if (queryInstanceNo && queryStatus) {
                    setSearchHelp({
                        sid: log.sid,
                        instance_no: log.instanceno,
                        doc_no: log.paramdocno,
                        from: '',
                        to: '',
                        status: log.callbackstatus
                    });
                }
                // handleExplorerDetail(response.result_list[0]);
            }
        })();
    }, []);

    useEffect(() => {
        fetchCompanyMaster();
    }, []);

    const handleChangeSearchHelp = <K extends keyof WorkflowCallBackLogParams>(
        key: K,
        value: WorkflowCallBackLogParams[K]
    ) => {
        setSearchHelp(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    const handleDateFromChange = (date: Date | null) => {
        setSearchHelp(prev => ({
            ...prev,
            from: date ? dayjs(date).format('YYYYMMDDHHmmss') : ''
        }));
    };

    const handleDateToChange = (date: Date | null) => {
        setSearchHelp(prev => ({
            ...prev,
            to: date ? dayjs(date).format('YYYYMMDDHHmmss') : ''
        }));
    };

    const mappingCompany = new Map<string, string>(
        companyMaster?.map(value => [value.sid, value.company_name])
    );

    const fetchCompanyMaster = async () => {
        try {
            loading.show();
            const response = await axios.get<MasterCompanyResponse>(
                '/v1/company_master',
                {
                    headers: {
                        Authorization:
                            'Bearer ' + localStorage.getItem('WF_APPLICATION')
                    }
                }
            );
            setCompanyMater(response.data.result_list);
        } finally {
            loading.hide();
        }
    };

    const fetchCallbackLog = async (params: WorkflowCallBackLogParams) => {
        if (params.status.length > 2) {
            params.status = '*';
        }

        if (params.doc_no === '' && params.status === '') {
            Swal.fire({
                title: 'กรุณาระบุ เงื่อนไข',
                text: `กรุณาระบุ เลขที่เอกสาร หรือ สถานะ`,
                icon: 'info',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok!'
            });

            return;
        }

        try {
            loading.show();

            const [, response] = await getWorkflowCallbackLog(params);

            if (response) {
                setWorkflowLogResponse(response);
                return response;
            }
        } finally {
            loading.hide();
        }
    };

    const handleSearch = async () => {
        await fetchCallbackLog(searchHelp);
    };

    const handleRefreshLog = async (id: number, instanceNo: string) => {
        Swal.fire({
            title: 'Refresh Log',
            text: `Instance Number: ${instanceNo}`,
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then(async result => {
            if (result.isConfirmed) {
                try {
                    loading.show();
                    const [, response] = await updateWorkflowCallbackLog({
                        id: id
                    });

                    if (response) {
                        await fetchCallbackLog(searchHelp);
                    }
                } finally {
                    loading.hide();
                }
            }
        });
    };

    const handleExplorerDetail = (logDetail?: LogCallBackInfo) => {
        setExplorerDetail(prev => !prev);

        if (logDetail) {
            setCallbackLogDetail(logDetail);
        }
    };

    const handleCheckboxChange = (value: string) => {
        setSearchHelp(prevState => {
            let newStatus = prevState.status.split(',').filter(Boolean);

            if (newStatus.includes(value)) {
                newStatus = newStatus.filter(item => item !== value);
            } else {
                newStatus.push(value);
            }

            const updatedStatus = newStatus.join(',');

            return {
                ...prevState,
                status: updatedStatus
            };
        });
    };

    return (
        <Container>
            <React.Fragment>
                <Row>
                    <Col className="import-export-actions">
                        <div
                            className="trapezoid-head"
                            style={{ width: '200px' }}
                        >
                            <span>Callback Log</span>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="mat-box">
                            <div
                                className="trapezoid trapezoid-purple"
                                style={{
                                    width: '200px',
                                    display: 'inline-block'
                                }}
                            >
                                <span>
                                    <i
                                        className="fa fa-search"
                                        aria-hidden="true"
                                    ></i>
                                    Search menu
                                    <div
                                        style={{
                                            display: 'inline-block',
                                            float: 'right'
                                        }}
                                    ></div>
                                </span>
                            </div>
                            <div className="mat-box mb-5 rounded bg-white p-3 shadow">
                                <Row>
                                    <Col>
                                        <div className="mt-2">
                                            <Row>
                                                <Col
                                                    xs={12}
                                                    md={3}
                                                >
                                                    <Form.Group
                                                        className="mb-3"
                                                        controlId="formBasicEmail"
                                                    >
                                                        <Form.Label>
                                                            Company Name :
                                                        </Form.Label>
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    selectdAllCompany
                                                                }
                                                                onChange={e => {
                                                                    e.persist();
                                                                    setSelectdAllCompany(
                                                                        prev =>
                                                                            !prev
                                                                    );
                                                                    handleChangeSearchHelp(
                                                                        'sid',
                                                                        '*'
                                                                    );
                                                                }}
                                                            />
                                                            <span className="ml-2">
                                                                เลือกทั้งหมด
                                                            </span>
                                                        </div>
                                                        <Input
                                                            type="select"
                                                            onChange={e => {
                                                                e.persist();
                                                                handleChangeSearchHelp(
                                                                    'sid',
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                            disabled={
                                                                selectdAllCompany
                                                            }
                                                        >
                                                            <option selected>
                                                                Please choose
                                                            </option>
                                                            {adminCompanies?.map(
                                                                (
                                                                    value,
                                                                    index
                                                                ) => (
                                                                    <option
                                                                        key={
                                                                            index
                                                                        }
                                                                        value={
                                                                            value.sid
                                                                        }
                                                                    >
                                                                        {
                                                                            value.company_name
                                                                        }
                                                                    </option>
                                                                )
                                                            )}
                                                        </Input>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col
                                                    xs={5}
                                                    md={3}
                                                >
                                                    <Form.Group
                                                        className="mb-3"
                                                        controlId="formBasicEmail"
                                                    >
                                                        <Form.Label>
                                                            เลขที่เอกสาร :
                                                        </Form.Label>
                                                        <Input
                                                            bsSize="sm"
                                                            value={
                                                                searchHelp.doc_no
                                                            }
                                                            onChange={e => {
                                                                e.persist();
                                                                handleChangeSearchHelp(
                                                                    'doc_no',
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col
                                                    xs={5}
                                                    md={3}
                                                >
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            Instance No. :
                                                        </Form.Label>
                                                        <Input
                                                            bsSize="sm"
                                                            value={
                                                                searchHelp.instance_no
                                                            }
                                                            onChange={e => {
                                                                e.persist();
                                                                handleChangeSearchHelp(
                                                                    'instance_no',
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col
                                                    xs={5}
                                                    md={1}
                                                >
                                                    <Form.Label>
                                                        สถานะ :
                                                    </Form.Label>
                                                    <div className="form-inline">
                                                        <Form.Group
                                                            className=""
                                                            controlId="formBasicCheckbox"
                                                        >
                                                            <Form.Check
                                                                type="checkbox"
                                                                id="checkWaiting"
                                                                label="WAITING"
                                                                checked={searchHelp.status.includes(
                                                                    'W'
                                                                )}
                                                                onClick={() => {
                                                                    handleCheckboxChange(
                                                                        'W'
                                                                    );
                                                                }}
                                                            />
                                                            <Form.Check
                                                                type="checkbox"
                                                                className="mx-5"
                                                                id="checkError"
                                                                label="ERROR"
                                                                checked={searchHelp.status.includes(
                                                                    'E'
                                                                )}
                                                                onClick={() => {
                                                                    handleCheckboxChange(
                                                                        'E'
                                                                    );
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={3}>
                                                    <Form.Group className="flex flex-col">
                                                        <Form.Label>
                                                            Date From :
                                                        </Form.Label>
                                                        <DatePicker
                                                            isClearable
                                                            selected={
                                                                searchHelp.from
                                                                    ? dayjs(
                                                                          searchHelp.from
                                                                      ).toDate()
                                                                    : undefined
                                                            }
                                                            onChange={
                                                                handleDateFromChange
                                                            }
                                                            customInput={
                                                                <Form.Control
                                                                    className="menu-form custom-datepicker"
                                                                    size="sm"
                                                                    placeholder="dd/mm/yyyy"
                                                                />
                                                            }
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="dd/mm/yyyy"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Group className="flex flex-col">
                                                        <Form.Label>
                                                            Date To :
                                                        </Form.Label>
                                                        <DatePicker
                                                            isClearable
                                                            selected={
                                                                searchHelp.to
                                                                    ? dayjs(
                                                                          searchHelp.to
                                                                      ).toDate()
                                                                    : undefined
                                                            }
                                                            onChange={
                                                                handleDateToChange
                                                            }
                                                            customInput={
                                                                <Form.Control
                                                                    className="menu-form custom-datepicker"
                                                                    size="sm"
                                                                    placeholder="dd/mm/yyyy"
                                                                />
                                                            }
                                                            dateFormat="dd/MM/yyyy"
                                                            placeholderText="dd/mm/yyyy"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col
                                                    md={1}
                                                    className="flex flex-col justify-end"
                                                >
                                                    <Form.Group>
                                                        <Button
                                                            variant="outline-info"
                                                            size="sm"
                                                            onClick={
                                                                handleSearch
                                                            }
                                                            className="whitespace-nowrap"
                                                        >
                                                            <FaSearch /> Search
                                                        </Button>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {!explorerDetail ? (
                                <CallbackLogTable
                                    mappingCompany={mappingCompany}
                                    workflowLogResponse={workflowLogResponse!}
                                    refreshLog={handleRefreshLog}
                                    explorerDetail={handleExplorerDetail}
                                />
                            ) : (
                                <CallbackLogDetail
                                    CallbackLogDetail={callbackLogDetail!}
                                    explorerDetail={handleExplorerDetail}
                                    mappingCompany={mappingCompany}
                                    refreshLog={handleRefreshLog}
                                />
                            )}
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        </Container>
    );
}

export default CallbackLog;
